import {
    type FC
} from "react";
import type ISidebarTriggerProps from "./type";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    useSidebarContext
} from "../../context";
import {
    PanelLeftClose as PanelLeftCloseIcon,
    PanelLeftOpen as PanelLeftOpenIcon,
    Menu as MenuIcon,
    X as XIcon
} from "lucide-react-native";
import {
    getSidebarAriaShortcut
} from "../../util";
import AnimatedIcon from "../../../animatedIcon";
import Button from "../../../button";

const SidebarTriggerIcon: NCoreUIKitIcon = ({
    customColor,
    color,
    size
}) => {
    const provider = useSidebarContext({
        part: "Sidebar.Trigger"
    });

    const isPhone = provider?.isPhone ?? false;

    return <AnimatedIcon
        fromIcon={isPhone ? MenuIcon : PanelLeftOpenIcon}
        toIcon={isPhone ? XIcon : PanelLeftCloseIcon}
        iconTransition={isPhone ? "morph" : "none"}
        isTransitioned={provider?.isOpen ?? true}
        customColor={customColor}
        color={color}
        size={size}
    />;
};

const SidebarTrigger: FC<ISidebarTriggerProps> = ({
    customLocalize: customLocalizeProp,
    customTheme: customThemeProp,
    isDisabled = false,
    onPress,
    title,
    ...props
}) => {
    const provider = useSidebarContext({
        part: "Sidebar.Trigger"
    });

    const customLocalize = customLocalizeProp ?? provider?.customLocalize;

    const customTheme = customThemeProp ?? provider?.customTheme;

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const isOpen = provider?.isOpen ?? true;

    const isPhone = provider?.isPhone ?? false;

    const getDefaultLabel = () => {
        if(isPhone) {
            return localize(isOpen ? "close-menu" : "open-menu");
        }

        return localize(isOpen ? "collapse-sidebar" : "expand-sidebar");
    };

    return <Button
        {...props}
        aria-keyshortcuts={getSidebarAriaShortcut({
            shortcut: provider?.shortcut ?? null
        })}
        aria-label={title ?? getDefaultLabel()}
        aria-controls={provider?.sidebarId}
        onPress={() => {
            onPress?.();

            provider?.handleToggle();
        }}
        customTheme={customTheme}
        icon={SidebarTriggerIcon}
        isDisabled={isDisabled}
        aria-expanded={isOpen}
        variant="ghost"
        type="neutral"
        size="medium"
    />;
};
export default SidebarTrigger;
